import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=587f5643"
import script from "@/controllers/componentHooks/inputs/select/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/inputs/select/index.js?vue&type=script&lang=js&external"
import style0 from "./Select.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports